<template>
  <div class="chart-wrap">
    <div class="top-hd">
      <h1> {{ chartTitle }}</h1>
      <div style="display: flex; gap: 12px;">
      <button class="img-save" type="button" style="width: 120px; background: #fff; color: #2a2c2f; border: 1px solid #2a2c2f;" @click="saveChartToImg()">이미지 저장</button>
      <button class="close-btn" type="button"  @click="popupClose()">닫기</button>
      </div>
    </div>
    <div class="chart-area">
      <div class="l">
        <h2 @click="saveChartToImg">차트 항목 선택</h2>
        <ul class="chart-menu">
          <li v-for="(data, index) in arrayRowItemFilterData" :key="index">
<!--          <li v-for="(data, index) in arrayRowItemFilterData" v-show="data.checked === true" :key="index">-->
            <button type="button" :class="{ on : activeButton === index}" @click="rowItemClick(index, data)"> {{ data.itemName }} </button>
          </li>
        </ul>
      </div>
      <div class="r">
        <div class="chart-type-list">
          <ul class="chart-type">
            <li><button type="button" @click="selectChart('column', 'columnGroup', true)" :class="selectChartIcon === 'columnGroup' ? 'chart-selected': ''" class="btn-chart-type1"><span class="hidden">막대차트</span></button></li>
            <li><button type="button" @click="selectChart('column', 'column', false)" :class="selectChartIcon === 'column' ? 'chart-selected': ''" class="btn-chart-type2"><span class="hidden">막대차트</span></button></li>
            <li><button type="button" @click="selectChart('line', 'line', true)" :class="selectChartIcon === 'line' ? 'chart-selected': ''" class="btn-chart-type3"><span class="hidden">꺽은선차트</span></button></li>
            <li><button type="button" @click="selectChart('spline', 'spline', true)" :class="selectChartIcon === 'spline' ? 'chart-selected': ''" class="btn-chart-type4"><span class="hidden">곡선차트</span></button></li>
            <li><button type="button" @click="selectChart('line', 'step', true)" :class="selectChartIcon === 'step' ? 'chart-selected': ''" class="btn-chart-type5"><span class="hidden">계단형차트</span></button></li>
            <li><button type="button" @click="selectChart('bar', 'barGroup', true)" :class="selectChartIcon === 'barGroup' ? 'chart-selected': ''" class="btn-chart-type6"><span class="hidden">바차트</span></button></li>
            <li><button type="button" @click="selectChart('bar', 'bar', false)" :class="selectChartIcon === 'bar' ? 'chart-selected': ''" class="btn-chart-type7"><span class="hidden">바차트</span></button></li>
            <li><button type="button" @click="selectChart('area', 'area', false)" :class="selectChartIcon === 'area' ? 'chart-selected': ''" class="btn-chart-type8"><span class="hidden">영역차트-꺽은선</span></button></li>
            <li><button type="button" @click="selectChart('areaspline', 'areaspline', false)" :class="selectChartIcon === 'areaspline' ? 'chart-selected': ''" class="btn-chart-type9"><span class="hidden">영역차트-곡선</span></button></li>
<!--            <li><button type="button" @click="selectChart('pie', 'pie', false)" :class="selectChartIcon === 'pie' ? 'chart-selected': ''" class="btn-chart-type10"><span class="hidden">파이</span></button></li>-->
<!--            <li><button type="button" @click="selectChart('polar', 'polar', false)" :class="selectChartIcon === 'polar' ? 'chart-selected': ''" class="btn-chart-type12"><span class="hidden">방사형</span></button></li>-->
          </ul>
          <div v-show="isShow" class="chart-option">
            <span v-show="!isIndexYn" class="option-check">
              <input type="checkbox" id="allValue" @change="allValueChange" v-model="allValueCheck">
              <label for="allValue">전체(또는 표본수, 사례수) 값을 제외하고 차트보기</label>
            </span>
            <span class="option-select">
              <select @change="onChangeYear" v-model="selectYearObject">
                <option :value="{}">년도 선택</option>
                <option v-for="(select, i) in arrayYearItemFilterData" :value="select">{{select.itemName}}</option>
              </select>
            </span>
            <span class="option-select">
              <MultiSelect ref="multiSelect" @select-update="updateSelect" :item="arrayRowItemFilterData" :level="0"></MultiSelect>
                <!-- arrayRowItemSub[0].itemLevel  2 부터
                  <MultiSelect @select-update="updateSelect" v-show="arrayRowItemSub.length > 0" :item="arrayRowItemSub" :index="'0'"></MultiSelect>
                -->
            </span>
          </div>
        </div>
        <div v-show="infoItem.msrUnitNm !== null && infoItem.msrUnitNm !== ''" class="chart-unit"><p>단위 : {{ infoItem.msrUnitNm }}</p>
        </div>
        <div class="ibchart-wrap">
          <div class="ibchart-box">
            <div id="chartDiv"></div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="ibchart-box">
      <div id="chartDiv"></div>
    </div>-->
	</div>

</template>

<script>
import $ from 'jquery'
import MultiSelect from "@/components/select/MultiSelect";
export default {
	name: 'ChartPopup',
	components: {
    MultiSelect
	},
	mounted() {
		//document.querySelector('body').style.overflowX = 'auto'
    if (window.opener === null || window.opener.openerVue === undefined) {
      alert("비정상적인 접근입니다.");
      // 필요시 후처리
    } else {
      this.arrayRowItemFilterData = window.opener.openerVue.$data.arrayRowItemFilterData;
      this.arrayRowItemTitleData = window.opener.openerVue.$data.arrayRowItemTitleData;
      this.arrayData = window.opener.openerVue.$data.arrayChartData;
      //this.arrayData = window.opener.openerVue.$data.arrayDataFilter;
      this.infoItem =  window.opener.openerVue.infoItem;
      this.chartSetOption =  window.opener.openerVue.chartSetOption;
      this.isIndexYn = window.opener.openerVue.isIndexYn;
      this.chartTitle = this.infoItem.tblKorNm;

      // 최근 5년치 데이터 처리
      if (this.last5Year){
        this.arrayYearItemFilterData = window.opener.openerVue.$data.arrayYearItemFilterData.slice(0,5);
      } else {
        this.arrayYearItemFilterData = window.opener.openerVue.$data.arrayYearItemFilterData;
      }

      let item = this.arrayRowItemFilterData[0];
      this.$refs.multiSelect.initSelect(item);
      let result = [];
      result.push(this.pathFilterStr(item.itemKeyPath, this.arrayRowItemTitleData))
      this.filterResult = result;
      this.filterApply(result)
    }
	},
  data () {
    return {
      arrayRowItemFilterData : []
      ,arrayRowItemTitleData : []
      ,arrayYearItemFilterData : []
      ,arrayData: {}
      ,arrayDataFilter: {}  // 차트를 생성하기 위한 초기 데이터
      ,activeButton: 0
      ,delimiterCha: '▷'   // 데이터처리 구분자
      ,chartOptions: {}
      ,chartSetOption: {}
      ,stblChartId: "chartDiv" // + this.itemIdx  // 차트 객체 ID
      ,arrayRowItemSub : {}
      ,infoItem : {}
      ,allValueCheck: false
      ,isLast : false
      ,chartType: 'column'
      ,chartName: 'columnGroup'
      ,stackYn: true
      ,isIndexYn: false
      ,selectYearObject: {}
      ,lastItemName: ''
      ,filterResult: []
      ,last5Year: true
      ,selectChartIcon: 'columnGroup'
      ,chartTitle:''
      ,isShow: true
    }
  },
  methods: {
    popupClose() {
      window.close()
    },
    setData () {},
    // 차트 항목 선택 이벤트 처리
    rowItemClick (index, item) {
      if (this.activeButton === index) {
        return;
      }
      this.activeButton = index;
      this.arrayRowItemSub = item.child
      this.$refs.multiSelect.initSelect(item);
      let result = [];
      result.push(this.pathFilterStr(item.itemKeyPath, this.arrayRowItemTitleData))
      this.filterResult = result;
      this.filterApply(result)
    },
    // 셀렉트 선택 완료 이벤트 처리
    updateSelect (isAll, param) {
      // 버튼 활성화 처리
      let index = this.arrayRowItemFilterData.findIndex(item => item.itemKeyPath === param)
      if (index > -1) {
        this.activeButton = index;
      }
      // 데이터 필터 처리
      let result = [];
      result.push(this.pathFilterStr(param, this.arrayRowItemTitleData));
      this.filterResult = result;
      this.filterApply(result)
    },
    // 년도 선택 이벤트 처리
    onChangeYear() {
      this.filterApply(this.filterResult)
    },
    // 전체 제외 체크박스 이벤트 처리
    allValueChange() {
      // 파이 차트 조건 처리
      if(!this.pieChartCheck()){
        return;
      }
      this.initChart(this.arrayDataFilter);
    },
    pieChartCheck() { // filterApply 호출하지않고 initChart() 를 직접 호출 하는경우
      if (this.chartType !== 'pie' && this.chartType !== 'polar' ||this.selectYearObject.itemName) {
        return true;
      } else {
        alert("해당 차트는 년도 선택이 필수입니다.");
        return false;
      }
    },
    // 차트 종류 선택 이벤트 처리
    selectChart(type, name, stack) {
      this.selectChartIcon = name;
      this.chartType = type;
      this.chartName = name;
      this.stackYn = stack;
      // 파이 차트 조건 처리
      if(!this.pieChartCheck()){
        return;
      }
      this.initChart(this.arrayDataFilter);
    },
    // 데이터 필터 처리
    filterApply(result) {

      if(!this.pieChartCheck()){
        return;
      }
      // 최상위 전체일 경우
      if (result.length === 0 ||  Object.keys(result[0]).length === 0) {
        if(!confirm("전체 데이터 조회시 차트가 정상적으로 표시되지 않을수 있습니다. 진행 하시겠습니까?")){
          return;
        }
      }
      this.arrayDataFilter = this.arrayData // 초기데이터
      // 년도 필터 처리
      if (this.selectYearObject.itemName) {
        this.arrayDataFilter = this.arrayDataFilter.filter(item => item[this.selectYearObject.filterKey] === this.selectYearObject.itemName);
      }

      let tempArrayFilteredData = [];
      result.forEach(filterItem => {
        let tempArrayData = this.arrayDataFilter // 필터된 데이터
        const arrKey = Object.keys(filterItem)
        arrKey.forEach(key => {
          tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
        })
        tempArrayFilteredData.push(...tempArrayData)
      })
      this.arrayDataFilter = tempArrayFilteredData;
      this.initChart(this.arrayDataFilter);
    },

    // 필터 조건 문자열로 변환
    pathFilterStr(keyStr, titleData) {
      // 주제,지표에 따른 처리
      const arrTitle = titleData.map(keys => keys.levelTitle === undefined ? keys : keys.levelTitle)
      const filter = keyStr.split(this.delimiterCha).splice(2)
      const result = {}
      filter.forEach((item, index) => {
        if (item !== '') {
          result[arrTitle[index]] = item
        }
        if (index === filter.length -1) {
          this.lastItemName = item
        }
      })
      return result;
    },

    // 차트 생성
    initChart(arrayData) {

      let colors = ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"];
      const seriesKeyFunc = item => {
        return this.chartSetOption.seriesKey.map(key => {
          return item[key]
        }).join(this.delimiterCha);
      }

      const stackKeyFunc = item => {
        return this.chartSetOption.stackKey.map(key => {
          return item[key]
        }).join(this.delimiterCha);
      }

      // 차트 데이터 처리
      const dataFunc = (arrayData, series, stack) => {
        let tempData = arrayData;
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);
        seriesArr.forEach((series, index) => {
          if (series && series.length > 0) {
            tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
          }
        })
        stackArr.forEach((stack, index) => {
         if (stack && stack.length > 0) {
           tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
         }
        })
        return tempData.map(item => item[this.chartSetOption.valueKey] === undefined ? 0 : item[this.chartSetOption.valueKey])
      }

      // 원 데이터에서 항목자체가 없거나 항목에 값이 없는경우 0으로 처리
      // 속도 저하 발생(차트의 모든 항목수 만큼 돌면서 값을 생성하기때문에 느림)
      const dataFunc2 =  (categories, arrayData, series, stack) => {
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);

        let result = []
        categories.forEach((category, years) => {
            let tempData = arrayData;
            tempData = tempData.filter(item => item[this.chartSetOption.categoriesKey] === category)
            seriesArr.forEach((series, index) => {
              if (series && series.length > 0) {
                tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
              }
            })
            stackArr.forEach((stack, index) => {
              if (stack && stack.length > 0) {
                tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
              }
            })
            //result.push(tempData.map(item => item[this.chartSetOption.valueKey] === undefined ? 0 : item[this.chartSetOption.valueKey]))
            // 항목자체가 없거나 항목에 값이 없을경우 0으로 처리
            result.push(tempData[0] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey]);
        })
        return result;
      }
      // 파이차트 데이터 생성
      const dataFuncPie =  (categories, arrayData, series, stack) => {
        let seriesArr = series.split(this.delimiterCha);
        let stackArr = stack.split(this.delimiterCha);

        let result = []
        categories.forEach((category, yearIndex) => {
          if (yearIndex !== 0) {  // 임시 테스트
            return;
          }
          let tempData = arrayData;
          tempData = tempData.filter(item => item[this.chartSetOption.categoriesKey] === category)
          seriesArr.forEach((series, index) => {
            if (series && series.length > 0) {
              tempData = tempData.filter(item => item[this.chartSetOption.seriesKey[index]] === series)
            }
          })
          stackArr.forEach((stack, index) => {
            if (stack && stack.length > 0) {
              tempData = tempData.filter(item => item[this.chartSetOption.stackKey[index]] === stack)
            }
          })

          // 항목자체가 없거나 항목에 값이 없을경우 0으로 처리
          result.push(stack);
          result.push(tempData[0] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey] === undefined ? 0 : tempData[0][this.chartSetOption.valueKey]);

        })
        return result;
      }

      // SET. 차트 생성 조건 셋팅
      let categories = [...new Set(arrayData.map(item => item[this.chartSetOption.categoriesKey]))];
      let series = [...new Set(arrayData.map(item => seriesKeyFunc(item)))];
      let stack = [...new Set(arrayData.map(item => stackKeyFunc(item)))];

      // 최근 5년치 데이터 처리
      if (this.last5Year) {
        categories = categories.slice(0, 5);
      }

      // 전체(또는 표본수, 사례수) 값을 제외하고 차트보기
      // CASE1. 첫번째 값 제거
      if (this.allValueCheck && stack.length > 0) {
        stack = stack.filter(item => item !== stack[0]);
      }
      // CASE2. 표본수, 사례수 명칭으로 제외 처리
      /*if (this.allValueCheck) {
        stack = stack.filter(item => item !== '표본수' && item !== '사례수');
        series = series.filter(item => item !== '표본수' && item !== '사례수');
      }*/

      let extraStackSize = 0;
      //console.log("groupWidth", groupWidth);
      //console.log("groupHeight", groupHeight);

      let seriesData = [];

      // SET DATA
      // CASE. 파이 차트일경우 처리
      if (this.chartType === 'pie' || this.chartType === 'polar') {
        let pieBaseWidth = 100 / series.length;
        let pieWidth = pieBaseWidth / 2;
        series.forEach((series, index) => {    // 구분 : 성별, 연령별
          let arrayPieData = [];
          stack.forEach((stack) => {  // 여가활동 : 사진촬영
            let data = dataFuncPie(categories, arrayData, series, stack);
            arrayPieData.push(data)
          })
          let template = {
            name: series,
            color: colors[index],
            data: arrayPieData,
            stack: stack,
            stackName : stack,
            center: [pieWidth + '%', '50%'],
            showInLegend: true
          }
          pieWidth = pieWidth + pieBaseWidth;
          seriesData.push(template)
        })
      } else {  // 파이 제외 차트
        stack.forEach((stack) => {
          series.forEach((series,  index) => {
            //let data = dataFunc(arrayData, series, stack);
            let data = dataFunc2(categories, arrayData, series, stack);
            let template = {
              name: series,
              color: colors[index],
              data: data,
              stack: stack,
              stackName : stack
            }
            // stack 여부에 따라 변경 처리
            if (!this.stackYn) {
              template.stack = stack + ' ' + series
              extraStackSize ++;
            }

            // 라인 타입일 경우 각 표두 항목을 표시
            if (this.chartType === 'line' || !this.stackYn) {
              template.dataLabels ={
                enabled:true,
                inside:false,
                formatter:function(){
                  return this.series.userOptions.stackName;
                }
              }
            } else { // 컬럼, 바 타입일 경우 첫번째에만 표두 항목을 표시
              if (index === 0) {
                template.dataLabels ={
                  enabled:true,
                  inside:false,
                  formatter:function(){
                    return this.series.userOptions.stackName;
                  }
                }
              }
            }
            seriesData.push(template)
          })

        })
      }

      // 차트 초기 속성
      this.chartOptions.initChartData = {
        chart: {
          type: this.chartType === 'polar' ? 'line' : this.chartType,   // column, line, bar
          //가로 스크롤 바
          scrollablePlotArea: {
            // minWidth: groupWidth,
            // minHeight: groupHeight,
            /*scrollPositionX: 1*/
          }
        },
        colors: ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"],
        xAxis: {
          categories : this.chartType === 'polar' ? stack : categories
        },
        yAxis: {
          title:{
            enabled: false
          }
        },
        tooltip: {},
        legend: {
          enabled: false,
          align:"right",
          verticalAlign:"middle",
          layout:"verical"
        },
        plotOptions: {
          series: {
            stacking: "normal",
            shadow: false
          },
          column:{
            showInLegend: false,
            events:{
              legendItemClick:function(){return false;}
            },
            pointWidth:30,
            groupPadding: 0.05,
            pointPadding: 0.15,
            allowPointSelect: true,
          }
        },
        series: seriesData
      }

      // 영역 차트일경우 투명도 설정
      if (this.chartName === 'area' || this.chartName === 'areaspline') {
        this.chartOptions.initChartData.plotOptions.area = {fillOpacity : 0.2};
      }

      if (this.chartName === 'step') {
        this.chartOptions.initChartData.plotOptions.line = {step : true};
      }

      if (this.chartType === 'pie') {
        this.chartOptions.initChartData.plotOptions.series.dataLabels = {format : "{point.name} {point.percentage:.1f} %"}
        this.chartOptions.initChartData.plotOptions.pie = {size : "70%",dataLabels: {enabled: true,distance: -50,}}
      }

      if (this.chartType === 'polar') {
        this.chartOptions.initChartData.chart.polar = true;
      }

      // chart 초기화
      createIBChart(this.stblChartId, this.stblChartId, {
        width: "100%",
        height: "500px"
        /*width: groupWidth,
        height: groupHeight*/
      });

      this.stblChart = window[this.stblChartId]
      this.stblChart.setOptions(this.chartOptions.initChartData,{redraw:true});
    },

    saveChartToImg() {
      let saveDivSelector = ".chart-wrap";
      saveDivSelector = "#chartDiv";
      if ($(saveDivSelector).length === 0) {
        console.log("생성된 차트가 없습니다.");
        return;
      }
      const saveImg = (uri, filename) => {
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.href = uri;
        link.download = filename;
        link.click();
        document.body.removeChild(link);
      };
      //document.querySelector(".chart-option").style.display = 'none';
      //document.querySelector(".close-btn").style.display = 'none';
      html2canvas(document.querySelector(saveDivSelector)).then(canvas => {
        saveImg(canvas.toDataURL(), this.chartTitle + '.png');
      });
      //document.querySelector(".chart-option").style.display = '';
      //document.querySelector(".close-btn").style.display = '';
    }

  }
}
</script>

<style scoped>

</style>
